export default{
    'GenerarPDF.VisualizadorPDF':'PDF Viewer',
    'GenerarPDF.Acercar':'Zoom in',
    'GenerarPDF.Alejar':'Zoom out',
    'GenerarPDF.Descargar':'Discharge PDF'
}